module.exports = __webpack_public_path__ + "img/15_39.fd0dae75.png";